//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'agreements-layout',
  components: {
    NavBar: () => import('../components/core/TheNavBar.vue'),
    BaseLayout: () => import('../components/core/BaseLayout.vue'),
  },
};
